module.exports = __webpack_public_path__ + "static/media/tentang.cce6406e.jpg";